/**
 * A decorator-driven AdonisJS library that lets you annotate Lucid ORM models with metadata to automatically generate CRUD controllers, validation rules, OpenAPI schemas, and a unified query interface.
 * @module @nhtio/lucid-resourceful
 */

/**
 * The current version of the package.
 *
 * @tip This is a constant that is replaced during the build process with the actual version of the package.
 */
export const version = __VERSION__

export { withResourceful } from '@/private/mixin'
export {
  setDefaultRelationsCacheService,
  isRelationCacheTarget,
  registerRelationCacheTarget,
  resetRelationCacheTargets,
} from '@/private/utils/cache_service_resolver'
export { registerRelationCacheTargetsForModel } from '@/private/utils/caching_preloader'
export {
  setDefaultOnRelationsCacheError,
  resetDefaultOnRelationsCacheError,
} from '@/private/utils/cache_error_handler'
export {
  setDefaultOnRelationsCacheEvent,
  resetDefaultOnRelationsCacheEvent,
} from '@/private/utils/cache_event_handler'
export type {
  CacheDuration,
  CacheServiceLike,
  RelationCacheEntryOptions,
  RelationsCacheServiceResolver,
} from '@/private/utils/cache_service_resolver'
export type { RelationsCacheErrorHandler } from '@/private/utils/cache_error_handler'
export type {
  RelationsCacheEventHandler,
  RelationCacheEvent,
  RelationCacheEventContext,
} from '@/private/utils/cache_event_handler'
export type {
  CacheMiddlewareHandler,
  CacheMiddlewareContext,
  CacheMiddlewareInput,
  CacheMiddlewarePhase,
  CacheMiddlewarePipeline,
} from '@/private/utils/cache_middleware'
export {
  resourcefulColumn,
  resourcefulComputed,
  resourcefulBelongsTo,
  resourcefulHasOne,
  resourcefulHasMany,
  resourcefulManyToMany,
  resourcefulHasManyThrough,
} from '@/private/decorators'
export * as errors from '@nhtio/lucid-resourceful/errors'
export * as definitions from '@nhtio/lucid-resourceful/definitions'

// Resourceful Router Macro
export { resourcefulRouterMacro } from '@/private/router_macro'

// OData Router Macro
export { odataRouterMacro } from '@/private/odata_macro'

// Adonis Integration
export { configure } from '@/integration/configure'
